import axios from './axios';

export const getWhitelabelDetails = async (): Promise<any> => {
  const res = await axios.get(`${process.env.REACT_APP_API_URL}/config/assets`);
  return res.data;
};
